/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type ArticleStateType = "available" | "deleted" | "draft" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type Article_editFieldsFragment$ref: FragmentReference;
export type Article_editFieldsFragment = {|
  +id: string,
  +title: ?string,
  +previewPicture: ?string,
  +foreignAgent: ?boolean,
  +previewAttribution: ?string,
  +body: ?string,
  +bodyHtml: ?string,
  +lead: ?string,
  +section: ?string,
  +category: ?string,
  +topics: ?$ReadOnlyArray<?{|
    +id: string,
    +name: ?string,
  |}>,
  +linkedArticles: ?$ReadOnlyArray<?{|
    +id: string,
    +title: ?string,
  |}>,
  +author: ?string,
  +hidden: ?boolean,
  +yaGenre: ?string,
  +isEvent: ?boolean,
  +infostring: ?boolean,
  +infostring_hot: ?boolean,
  +showInYandexNews: ?boolean,
  +showInYandexZen: ?boolean,
  +availableAt: ?string,
  +seoTitle: ?string,
  +seoDescription: ?string,
  +seoKeywords: ?string,
  +preview: ?{|
    +id: string,
    +filename: ?string,
    +description: ?string,
  |},
  +combinedPreviewVideo: ?{|
    +id: string,
    +filename: ?string,
    +description: ?string,
  |},
  +mediaFiles: ?$ReadOnlyArray<?{|
    +id: string
  |}>,
  +state: ArticleStateType,
  +mainPageOrder: number,
  +$refType: Article_editFieldsFragment$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v2 = [
  v0,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "filename",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "Article_editFieldsFragment",
  "type": "Article",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    v1,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "previewPicture",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "foreignAgent",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "previewAttribution",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "body",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "bodyHtml",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "lead",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "section",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "category",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "topics",
      "storageKey": null,
      "args": null,
      "concreteType": "Topic",
      "plural": true,
      "selections": [
        v0,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "linkedArticles",
      "storageKey": null,
      "args": null,
      "concreteType": "Article",
      "plural": true,
      "selections": [
        v0,
        v1
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "author",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hidden",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "yaGenre",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isEvent",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "infostring",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "infostring_hot",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showInYandexNews",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showInYandexZen",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "availableAt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "seoTitle",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "seoDescription",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "seoKeywords",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "preview",
      "storageKey": null,
      "args": null,
      "concreteType": "MediaFile",
      "plural": false,
      "selections": v2
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "combinedPreviewVideo",
      "storageKey": null,
      "args": null,
      "concreteType": "MediaFile",
      "plural": false,
      "selections": v2
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "mediaFiles",
      "storageKey": null,
      "args": null,
      "concreteType": "MediaFile",
      "plural": true,
      "selections": [
        v0
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "state",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "mainPageOrder",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '0b01713fd4b41f232d0e66f61e24fe9e';
module.exports = node;



// WEBPACK FOOTER //
// src/components/articles/__generated__/Article_editFieldsFragment.graphql.js